export type PageLocale = "en" | "pt-BR";

export const getPageLocale = (pathname: string): PageLocale =>
  pathname.startsWith("/pt-br/") ? "pt-BR" : "en";

export const localizedPath = (path: string, locale: PageLocale) =>
  locale === "pt-BR" ? `/pt-br${path}` : path;

export const getPageMarket = (locale: PageLocale, search: string) =>
  locale === "pt-BR" || new URLSearchParams(search).get("market") === "BR"
    ? "BR"
    : undefined;

export const partnerCallHref = (
  locale: PageLocale,
  location: string,
  campaign: string,
  search: string,
) => {
  const incoming = new URLSearchParams(search);
  const params = new URLSearchParams({
    source: "openai-partner",
    location,
    utm_source: incoming.get("utm_source") || "openai-partner",
    utm_medium: incoming.get("utm_medium") || "website",
    utm_campaign: incoming.get("utm_campaign") || campaign,
  });
  for (const key of ["utm_content", "utm_term"]) {
    const value = incoming.get(key);
    if (value) params.set(key, value);
  }
  params.set("language", locale);
  const market = getPageMarket(locale, search);
  if (market) params.set("market", market);
  return `${localizedPath("/ai-call", locale)}?${params}`;
};
